export enum FieldVariant {
  form,
  dataRow,
}
